import React from 'react'
import About from './About'
import Hero from './Hero'
import Navbar from './Navbar'
import Project from './Project'
import Sidebar from './Sidebar'
import Skills from './Skills'
import Contact from './Contact'
import Footer from './Footer'

export default function Landing() {
    return (
        <div className="">
            <Navbar/>
            <Sidebar/>
            <Hero/>
            <div className="p-1 mt-10 mb-10"></div>
            <About/>
{/*             <Experience/>  */}
            <Project/>
            <Skills/>
            <Contact/>
            <Footer/>
        </div>
    )
}
